(function () {
    "use strict";

    Controllers.ClientPortalController = class ClientPortalController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector) {
            super($scope, $injector);
            this.__objectType = 'ClientPortalController';
        }
    };

}());





